<script setup lang="ts">
import { Badge, useToast } from 'primevue';

defineProps<{ id: number }>();

const toast = useToast();

const onClick = (e:MouseEvent) => {
  const val = (e.target as HTMLElement).innerHTML;
  navigator.clipboard.writeText(val).then(() => {
    toast.add({
      severity: 'success',
      summary: `Analyze study ID copied: ${val}`,
      life: 4000,
    });
  });
};
</script>

<template>
  <Badge
    title="Analyze study ID. Click to copy."
    class="font-mono cursor-pointer bg-purple-100"
    severity="secondary"
    @click.stop="onClick"
  >
    <span style="padding-top: 2px;">{{id}}</span>
  </Badge>
</template>
